module.exports = __webpack_public_path__ + "static/media/preview4-small.14dcce70.jpg";